const styles = theme => ({
  tableCenter: {
    textAlign: "center"
  },
  mainContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: "100vh",
    flexDirection: "column",
    fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
    fontSize: "14px"
  },
  container: {
    maxWidth: "1215px",
    margin: "auto",
    [theme.breakpoints.down("lg")]: {
      width: "calc(100% - 30px)"
    }
  },
  largeButton: {
    color: "#fff",
    padding: "7px 0",
    width: "174px",
    fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
    [theme.breakpoints.down("xs")]: {
      position: "static",
      right: "0",
      padding: "7px 6px",
      minWidth: "98px"
    }
  },
  headingWrap: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "30px",
    paddingBottom: "25px",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "50px",
      paddingBottom: "10px"
    }
  },
  headingButtonWrap: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      display: "inherit"
    }
  },

  searchInput: {
    background: "#fff",
    minWidth: "187px",
    height: "40px",
    padding: "0 5px 0 10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "4px",
    border: "solid 1px #eeeeee",
    boxShadow: "none",

    "& input": {
      padding: "0 8px",
      fontSize: "13px",
      fontFamily: "titilliumlight, Helvetica Neue, sans-serif"
    },

    "& button": {
      padding: "5px"
    },

    "& svg": {
      fill: "#adadad",
      fontSize: "20px"
    }
  },
  headingWrapheading: {
    fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
    textTransform: "uppercase",
    color: "#323233",
    fontSize: "22px",
    margin: "25px 0",
    [theme.breakpoints.down("xs")]: {
      margin: "10px 0"
    }
  },
  searchData: {
    width: "204px",
    padding: "13px 20px",
    border: "1px solid #eeeeee",
    borderRadius: "4px"
  },
  innerWrap: {
    minHeight: "calc(100vh - 100px)",
    margin: "0 80px",
    [theme.breakpoints.down("sm")]: {
      margin: "0"
    }
  },
  dashboardTable: {
    overflow: "auto",
    paddingBottom: "15px",
    "& table": {
      [theme.breakpoints.down("sm")]: {
        whiteSpace: "nowrap"
      }
    },

    "& th": {
      fontSize: "14px",
      color: "#323233",
      fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
      border: "none",
      padding: "12px 20px 23px 20px"
    },
    "& thead": {
      background: "#fff",
      whiteSpace: "nowrap"
    },

    "& tbody": {
      background: "#fff"
    },
    "& td": {
      fontSize: "14px",
      color: "#96989b",
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
      border: "none",
      padding: "12px 20px",
      position: "relative"
    }
  },
  showingTile: {
    "& a": {
      fontSize: "14px",
      color: "#ea4367",
      textDecoration: "none",
      width: "38px",
      height: "22px",
      background: "rgba(234, 67, 103, 0.1)",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "2px",
      boxShadow: "0 2px 3px 0 rgba(220, 220, 220, 0.5)"
    }
  },

  actionTile: {
    "& a": {
      textDecoration: "none",
      marginRight: "5px"
    }
  },

  paginationSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
    marginBottom: "20px",
    "& div:first-child": {
      background: "#fff",
      height: "45px",
      borderRadius: "25px",
      boxShadow: "0 2px 14px 0 rgba(225, 225, 225, 0.5)",
      minHeight: "auto"
    }
  },

  copyright: {
    fontSize: "13px",
    color: "#58637d",
    fontFamily: "montserratregular, Helvetica Neue, sans-serif",
    padding: "10px",
    textAlign: "center",
    "& span": {
      color: "#ff3f79"
    }
  },
  pageLoader: {
    height: "calc(100vh - 60px)",
    width: "100%",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  // Status Dropdown start here
  accountStatusDropdown: {
    position: "relative",
    "& button": {
      padding: "5px",
      "&:hover": {
        background: "none"
      }
    },
    "& svg": {
      fontSize: "20px"
    }
  },

  StatusDropdown: {
    background: "#f5f5f5",
    border: "1px solid #eae9e9",
    position: "absolute",
    top: "30px",
    left: "0",
    zIndex: "1",
    minWidth: "100px",
    "& a": {
      display: "block",
      textDecoration: "none",
      padding: "2px 8px"
    }
  },

  textSuccess: {
    color: "#25a249"
  },
  textDanger: {
    color: "#aa0000"
  },
  noResultFound: {
    textAlign: "center",
    fontSize: "20px",
    fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
    color: "#ea4367",
    margin: "20px 0"
  }
});
export default styles;
